<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        @select-all="selectAll"
        @unselect-all="unselectAll"
      ></item-form>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import { mapGetters } from "vuex";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("Post", "post"),
    CreateGroupPermissionMixin("Post"),
    CreateCodeTableFetchMixin(["CodeEmployeeType"]),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  methods: {
    OnCreateNew() {
      // Set default author as current user
      this.item.author = this.currentUser.id;
      this.selectAll();
    },
    selectAll() {
      var code_employee_type_ids = [];
      if (this.optionCodeEmployeeTypeItems) {
        this.optionCodeEmployeeTypeItems.forEach((item) => {
          if (item.active_end_date === null) {
            code_employee_type_ids.push(item.id);
          }
        });

        this.item.employee_type = code_employee_type_ids;
      }
    },
    unselectAll() {
      this.item.employee_type = [];
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser"]),
    title() {
      if (this.create) {
        return "Create Post";
      }

      return "Edit Post";
    },
  },
};
</script>
